import React from 'react';
import { CoinData } from '../../data/coinList';
import { TrendingUp, TrendingDown } from 'lucide-react';

interface CoinStatsProps {
  coin: CoinData;
}

const CoinStats: React.FC<CoinStatsProps> = ({ coin }) => {
  const stats = [
    {
      label: '24h Low / 24h High',
      value: `$${(coin.current_price * 0.95).toFixed(2)} / $${(coin.current_price * 1.05).toFixed(2)}`,
    },
    {
      label: '7d Low / 7d High',
      value: `$${(coin.current_price * 0.88).toFixed(2)} / $${(coin.current_price * 1.12).toFixed(2)}`,
    },
    {
      label: 'Trading Volume / Market Cap',
      value: `${((coin.total_volume / coin.market_cap) * 100).toFixed(2)}%`,
    },
    {
      label: 'Market Cap Rank',
      value: `#${coin.rank}`,
    },
    {
      label: 'All-Time High',
      value: `$${(coin.current_price * 2.5).toFixed(2)}`,
      change: '-60.0%',
      date: '6 months ago',
      negative: true,
    },
    {
      label: 'All-Time Low',
      value: `$${(coin.current_price * 0.1).toFixed(2)}`,
      change: `+${((coin.current_price / (coin.current_price * 0.1) - 1) * 100).toFixed(0)}%`,
      date: '2 years ago',
      negative: false,
    },
  ];

  return (
    <div>
      <h3 className="text-lg font-semibold mb-4">{coin.symbol.toUpperCase()} Price Statistics</h3>
      <div className="space-y-3">
        {stats.map((stat, index) => (
          <div key={index} className="flex justify-between items-start py-3 border-b border-zinc-800 last:border-0">
            <span className="text-sm text-zinc-400">{stat.label}</span>
            <div className="text-right">
              <div className="text-sm font-medium">{stat.value}</div>
              {stat.change && (
                <div className="flex items-center justify-end space-x-1 mt-1">
                  {stat.negative ? (
                    <TrendingDown className="w-3 h-3 text-red-500" />
                  ) : (
                    <TrendingUp className="w-3 h-3 text-green-500" />
                  )}
                  <span className={`text-xs ${stat.negative ? 'text-red-500' : 'text-green-500'}`}>
                    {stat.change}
                  </span>
                  <span className="text-xs text-zinc-500">{stat.date}</span>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CoinStats;